import * as S from './Card.styles';

type CardProps = {
  children: React.ReactNode;
};
export function Card(props: CardProps): React.ReactElement {
  const { children } = { ...props };

  return <S.Container>{children}</S.Container>;
}
